import React, { Component, createRef } from "react";

import "component/list/CategoryGames/styles.scss";

class CategoryGames extends Component {
  constructor(props) {
    super(props);
    this.endRef = createRef();
  }

  componentDidMount() {
    this.initObserver();
    if (this.props.hasNoFilters) {
      this.props.fetchGames();
    }
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.endRef.current && this.props.onReachEnd) {
                this.props.onReachEnd();
              }
            }
          });
        },
        {
          rootMargin: "0px 0px 0px 0px",
          threshold: 0.1,
        }
      );
      observer.observe(this.endRef.current);
    } else {
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      (this.props.sorting && this.props.sorting !== prevProps.sorting) ||
      (this.props.sortBy && this.props.sortBy !== prevProps.sortBy) ||
      (this.props.refreshList &&
        prevProps.refreshList !== this.props.refreshList &&
        this.props.fetchGames)
    ) {
      this.props.fetchGames();
    }
  }

  render() {
    let ItemComponent = this.props.itemComponent;

    return (
      <div className="category-games row nopadding">
        {this.props.games &&
          this.props.games.get("items").map((game, key) => {
            let linkDemo = game.get("links").find((link) => {
              return link.get("rel") === "launch.demo";
            });
            let linkReal = game.get("links").find((link) => {
              return link.get("rel") === "launch.real";
            });
            let linkDetails = game.get("links").find((link) => {
              return link.get("rel") === "game.details";
            });

            return (
              <div className={`col col-item`} key={key}>
                <ItemComponent
                  game={game}
                  linkDemo={linkDemo}
                  linkReal={linkReal}
                  linkDetails={linkDetails}
                  host={this.props.host}
                  key={key}
                  isMobile={this.props.isMobile}
                  onClick={(playType) => {
                    let gameId = game.get("gameId");

                    if (linkReal && this.props.isOneClickPlayEnabled)
                      return this.props.onGameItemClickHandler({
                        game,
                        gameId,
                        playType: linkReal.get("rel"),
                      });
                    if (linkDemo && this.props.isOneClickPlayEnabled)
                      return this.props.onGameItemClickHandler({
                        game,
                        gameId,
                        playType: linkDemo.get("rel"),
                      });

                    return this.props.onGameItemClickHandler({
                      game,
                      gameId,
                      playType,
                    });
                  }}
                  onShowActionClick={() => {
                    this.launchActions(game);
                  }}
                  currency={this.props.currency}
                  symbol={this.props.symbol}
                  imageFormat={this.props.imageFormat}
                  latestBroadcast={this.props.latestBroadcast}
                  isOneClickPlayEnabled={this.props.isOneClickPlayEnabled}
                />
              </div>
            );
          })}
        <div
          className={`col col-end col-item ${
            this.props.isLoading ||
            (!this.props.isLoading && !this.props.isLoadingNext)
              ? ""
              : "d-none"
          } ${this.props.hasNextPage ? "" : "d-none"}`}
          ref={this.endRef}
        >
          <ItemComponent />
        </div>
        {(this.props.isLoading ||
          this.props.isLoadingNext ||
          this.props.hasNextPage) &&
          [...Array(4)].map((item, key) => {
            return (
              <div className={`col col-item skeleton`} key={key}>
                <ItemComponent key={key} isMobile={this.props.isMobile} />
              </div>
            );
          })}
      </div>
    );
  }
}

export default CategoryGames;
